var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e3-image-thumbnail-box"},[_c('div',{staticClass:"e3-image-thumbnail",class:{'e3-pointer' : _vm.hasPointer},style:({ 'background-image': 'url(' + _vm.url + '), url(' + _vm.image + ')' })}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }